import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'

import { MainButton, CancelButton } from 'components/button'
import Modalizer from 'components/modalizer/modalizer'
import binderActions from 'redux/actions/binderActions'
import generalActions from 'redux/actions/generalActions'
import styles from './binders_notes_modal.scss'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { localize } from 'helpers/translator'
import MultiSelectDropdown from 'components/multi_select_dropdown/multi_select_dropdown'

const maxClasses = 10

class NotesModal extends Component {

	constructor(props) {
		super(props)
		this.state = { value: '', currentLesson: 0, self_paceds: [] }
		this.goBack = this.goBack.bind(this)
		this.goNext = this.goNext.bind(this)
		this.selfPacedSelected = this.selfPacedSelected.bind(this)
		this.self_paced_list = []
		for (let i = 1; i <= maxClasses; i++) {
			this.self_paced_list.push({
				id: i,
				value: localize('binders_notesModal_lessons_' + i),
			})
		}
	}

	goBack() {
		if (this.state.currentLesson === 0) {
			this.cancelNotes()
		} else {
			const currentLessonNum = this.state.currentLesson - 1
			this.updateNotesValue(currentLessonNum)
			this.setState({currentLesson: currentLessonNum})
		}
	}

	goNext() {
		if (this.state.self_paceds.length === 0) {
			this.props.actions.noSelfPaceds()
		} else {
			this.saveNotes()
			if (this.state.currentLesson === this.props.lessons_picker.selected_lessons.length - 1) {
				this.cancelNotes()
			} else {
				const currentLessonNum = this.state.currentLesson + 1
				this.updateNotesValue(currentLessonNum)
				this.setState({currentLesson: currentLessonNum})
			}
		}
	}

	selfPacedSelected(value) {
		this.setState({self_paceds: [value.pop()]})
	}

	componentDidMount() {
		this.updateNotesValue(this.state.currentLesson)
	}

	updateNotesValue(lessonNum) {
		const currentLessonUID = this.props.lessons_picker.selected_lessons[lessonNum]
		const value = this.props.binders.current.notes[currentLessonUID] || ''
		const self_paceds = this.props.binders.current.self_paceds[currentLessonUID] ? [this.props.binders.current.self_paceds[currentLessonUID]] : [1]
		this.setState({value, self_paceds})
	}

	saveNotes() {
		const currentLessonUID = this.props.lessons_picker.selected_lessons[this.state.currentLesson]
		this.props.actions.saveNotes(this.props.binders.current.entityUID, currentLessonUID, this.state.value, this.state.self_paceds[0], this.props.lessons_picker.selected_lessons.length === this.state.currentLesson - 1)
	}

	cancelNotes() {
		this.props.actions.cancelNotes()
	}

	handleChange(event) {
		this.setState({value: event.target.value})
	}

	getSelectedField() {
		return {
			value: this.state.self_paceds,
			initialValue: '',
		}
	}

	render() {
		const backText = this.state.currentLesson === 0 ? localize('global_cancel') : localize('global_back')
		const nextText = this.state.currentLesson === (this.props.lessons_picker.selected_lessons.length - 1) ? 'Finish' : 'Next'
		const currentLessonData = this.props.lessons[this.props.lessons_picker.selected_lessons[this.state.currentLesson]]
		return (
			<Modalizer modalName={this.props.modalName} width='502px' closeAction={() => this.props.actions.closeModal(this.props.modalName)}>
				<div styleName='container'>
					<h2 styleName='title'>
						<span styleName='title-text'>{localize('binders_notesModal_title')}</span> {currentLessonData.data.name}
					</h2>
					<p styleName='subtitle'>{localize('binders_notesModal_desc')}</p>
					<div styleName='details'>
						<div styleName='details_cover'>
							<img styleName='details_cover_image' src={currentLessonData.data.thumb} alt="" />
						</div>
						<textarea styleName='details_notes' value={this.state.value} onChange={this.handleChange.bind(this)} placeholder={localize('binders_notesModal_placeholder')}></textarea>
					</div>
					<div styleName='lessons'>
						<p styleName='lessons-title'>{localize('binders_notes_lessons_title')}</p>
						<MultiSelectDropdown
							field = {this.getSelectedField()}
							positionTop = {true}
							tabIndex={-1}
							disabled={false}
							blurAfterSelect={true}
							placeholder={localize('binders_notes_lessons_placeholder')}
							options={this.self_paced_list}
							onChange={this.selfPacedSelected} />
					</div>
					<div styleName='btn-bar'>
						<div styleName='btn-bar_button'>
							<CancelButton onClick={this.goBack}>{backText}</CancelButton>
						</div>
						<div styleName='btn-bar_button'>
							<MainButton onClick={this.goNext}>{nextText}</MainButton>
						</div>
					</div>
				</div>
			</Modalizer>
		)
	}
}

NotesModal.propTypes = {
	actions: PropTypes.object,
	binders: PropTypes.object,
	entityUID: PropTypes.string,
	modalName: PropTypes.string,
	lessonImage: PropTypes.string,
}

function mapStateToProps(state) {
	return {
		binders: state.binders,
		lessons_picker: state.lessonsPicker,
		lessons: state.lessons,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		saveNotes: binderActions.saveNotes,
		noSelfPaceds: binderActions.noSelfPaceds,
		cancelNotes: binderActions.cancelNotes,
		closeModal: generalActions.closeModal,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(NotesModal, styles, {allowMultiple: true}))
